// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sideNavTree {
    flex: 1 1 auto;
    width: 18em;
    margin-right: 10px;
    overflow: hidden;
}

.iconDropDown {
    width: 200px;
}

.iconDropDownContent {
    height: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/navigation/structure/navigation.structure.settings.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".sideNavTree {\n    flex: 1 1 auto;\n    width: 18em;\n    margin-right: 10px;\n    overflow: hidden;\n}\n\n.iconDropDown {\n    width: 200px;\n}\n\n.iconDropDownContent {\n    height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
